(function(){

    'use strict';

    let disclaimerAgree = document.querySelectorAll('.disclaimer-agree'),
        modal = document.querySelector('.iwt-tool-disclaimer');

    if(modal) {
        if(!getCookie("iwt-disclaimer")) {
            modal.classList.remove('hidden');

            for (let button of disclaimerAgree) {
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    modal.classList.toggle('hidden');
                    document.cookie = "iwt-disclaimer=agree";
                });
            }

        }
    }




}());
